import { render } from "./SupportReport.vue?vue&type=template&id=2aed6c72&scoped=true"
import script from "./SupportReport.vue?vue&type=script&lang=js"
export * from "./SupportReport.vue?vue&type=script&lang=js"

import "./SupportReport.vue?vue&type=style&index=0&id=2aed6c72&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aed6c72"]])

export default __exports__